import React, { useEffect } from 'react';
import InputField from '../../../components/CustomFields/InputField';
import { academyLogger } from "utils/logger";

const ContactPersonDetails = ({ student = {}, handleNestedChange }) => {
    useEffect(() => {
        // Log the applicant data to check if contactPersonList exists
        academyLogger.info('Applicant Data:', student);
        academyLogger.info('Contact Person List:', student.contactPersonList);
    }, [student]);

    if (!student.contactPersonList || student.contactPersonList.length === 0) {
        return (
            <section className="text-center">
                <p>No contact person details available.</p>
            </section>
        );
    }

    return (
        <section className="">
            <h2 className="text-lg font-semibold text-[#824296] text-center">Contact Person</h2>
            {student.contactPersonList?.map((contact, index) => (
                <div key={index} className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <InputField
                        id={`contactFirstName-${index}`}
                        label="First Name *"
                        value={contact.firstName}
                        onChange={(e) =>
                            handleNestedChange("contactPersonList", index, "firstName", e.target.value)
                        }
                    />
                    <InputField
                        id={`contactLastName-${index}`}
                        label="Last Name *"
                        value={contact.lastName}
                        onChange={(e) =>
                            handleNestedChange("contactPersonList", index, "lastName", e.target.value)
                        }
                    />
                    <InputField
                        id={`contactEmail-${index}`}
                        label="Email *"
                        value={contact.email}
                        onChange={(e) =>
                            handleNestedChange("contactPersonList", index, "email", e.target.value)
                        }
                        type="email"
                    />
                    <InputField
                        id={`contactPhoneNumber-${index}`}
                        label="Mobile Number *"
                        value={contact.phoneNumber}
                        onChange={(e) => {
                            const inputValue = e.target.value.replace(/[^\d]/g, "");
                            const maxLength = 10;

                            if (inputValue.startsWith("91")) {
                                const numberPart = inputValue.slice(2, 12);
                                const formattedValue = `+91 ${numberPart}`;
                                handleNestedChange("contactPersonList", index, "phoneNumber", formattedValue);
                            } else {
                                const numberPart = inputValue.slice(0, maxLength);
                                const formattedValue = `+91 ${numberPart}`;
                                handleNestedChange("contactPersonList", index, "phoneNumber", formattedValue);
                            }
                        }}
                        inputProps={{
                            maxLength: 14, // +91 and 10 digits
                        }}
                    />
                </div>
            ))}
        </section>
    );
};

export default ContactPersonDetails;
